import { FitnessThatGetsYou } from '@pass-frontend/abyss/common/components/fitness-that-gets-you/ui';
import { StackMembership } from '@pass-frontend/abyss/common/components/stack-membership/ui';
import {
  GymPartnersNew,
  GymPartners,
  GymSearch,
  HeroComponent as CommonHeroComponent,
} from '@pass-frontend/abyss/features/landing/ui';
import {
  Faq,
  BenefitsOverviewLegacy,
  BenefitsOverview,
  MembershipOverview,
  HeroComponent,
} from '@pass-frontend/abyss/features/landing/ui/commercial';
import { env } from '@pass-frontend/features/configuration/util';
import { commercialGymPartnersProps } from '@pass-frontend/features/standalone/data-access';
import { newCommercialGymPartnersProps } from '@pass-frontend/features/standalone/data-access';

const { FF_ENABLE_LANDING_PAGE_NEW_LAYOUT } = env();

export function Index() {
  return FF_ENABLE_LANDING_PAGE_NEW_LAYOUT ? (
    <>
      <HeroComponent />
      <BenefitsOverview />
      <GymPartnersNew {...newCommercialGymPartnersProps} />
      <MembershipOverview />
      <GymSearch isCommercial />
      <StackMembership />
    </>
  ) : (
    <>
      <CommonHeroComponent isCommercial />
      <BenefitsOverviewLegacy />
      <GymPartners {...commercialGymPartnersProps} />
      <GymSearch isCommercial />
      <Faq />
      <FitnessThatGetsYou />
    </>
  );
}

export default Index;
